import { useTrainLogic } from '@/hooks/useTrainLogic';
import { TrainForm } from '@/components/company/train/TrainForm';
import { TrainFilters } from '@/components/company/train/TrainFilters';
import { trainColumns } from '@/components/company/train/trainColumns';
import { trainFields } from '@/components/company/train/trainFields';
import CompanyHeader from '@/components/company/CompanyHeader';
import MainTable from '@/components/company/table/MainTable';
import { toast } from 'react-toastify';

export default function Train() {
  const {
    formControl,
    formRef,
    formMode,
    setFormMode,
    setSelectedRow,
    allPublished,
    isLoading,
    displayData,
    handleSave,
    handleDelete,
    bulkPublishTrain,
    searchTerm,
    setSearchTerm,
    selectedRole,
    setSelectedRole,
    selectedCategory,
    setSelectedCategory,
    selectedStatus,
    setSelectedStatus,
    pageConfig,
    setPageConfig,
    reset,
    currentTenant,
    fetchData,
    roleOptions,
    orgCharts,
  } = useTrainLogic();

  const categoryOptions = [
    { label: 'Attitude', value: 'Attitude' },
    { label: 'Skill', value: 'Skill' },
    { label: 'Knowledge', value: 'Knowledge' },
  ];

  return (
    <section className="w-full">
      <CompanyHeader
        title="Train The Trainer"
        description="Manage training programs and trainer development initiatives."
        onCreate={() => {
          reset({ name: '', type: '' });
          setFormMode('add');
        }}
        onPublish={async value => {
          if (!currentTenant?.id) return;
          try {
            await bulkPublishTrain(currentTenant.id, value);
            await fetchData();
          } catch {
            toast.error('Failed to bulk publish');
          }
        }}
        isPublished={allPublished}
      />

      <div className="mx-5 border-b border-gray-200" />

      {formMode && orgCharts.length > 0 && (
        <TrainForm
          formControl={formControl}
          formRef={formRef}
          fields={trainFields(roleOptions, categoryOptions)}
          formMode={formMode}
          handleSave={handleSave}
          resetForm={() => {
            setFormMode(null);
            setSelectedRow(null);
          }}
        />
      )}

      <TrainFilters
        searchTerm={searchTerm}
        setSearchTerm={(val: string) => {
          setSearchTerm(val);
          setPageConfig(prev => ({ ...prev, page: 0 }));
        }}
        selectedRole={selectedRole}
        setSelectedRole={(val: string) => {
          setSelectedRole(val);
          setPageConfig(prev => ({ ...prev, page: 0 }));
        }}
        selectedCategory={selectedCategory}
        setSelectedCategory={(val: string) => {
          setSelectedCategory(val);
          setPageConfig(prev => ({ ...prev, page: 0 }));
        }}
        selectedStatus={selectedStatus}
        setSelectedStatus={(val: string) => {
          setSelectedStatus(val);
          setPageConfig(prev => ({ ...prev, page: 0 }));
        }}
        clearFilters={() => {
          setSearchTerm('');
          setSelectedRole('');
          setSelectedCategory('');
          setSelectedStatus('');
          setPageConfig(prev => ({ ...prev, page: 0 }));
        }}
        roleOptions={roleOptions}
        categoryOptions={categoryOptions}
      />

      <MainTable
        showHeader={false}
        isLoading={isLoading}
        data={{
          content: displayData.content as unknown as { [key: string]: unknown }[],
          totalElements: displayData.totalElements,
          totalPages: displayData.totalPages,
        }}
        columns={trainColumns}
        pageConfig={pageConfig}
        setPageConfig={setPageConfig}
        onEdit={row => {
          reset(row);
          setFormMode('edit');
          setSelectedRow(row);
        }}
        onDelete={handleDelete}
        showActions
        useConfirmDelete={true}
      />
    </section>
  );
}
